import React, { useContext, useState } from 'react'

import ProductAddToBasket from '@/components/Product/ProductAddToBasket'
import { Product } from '@/src/types/api-types'
import getProductQuantityPcb from '@/lib/getProductQuantityPcb'
import ProfileContext from '@/components/Context/ProfileContext'
import ProductQtyInput, { getInitialDisplayedQty } from '@/components/Product/ProductQtyInput'

type Props = {
  product: Product
  declination?: string
}

const ProductAddPad: React.FC<Props> = ({ product }) => {
  // Aligne l'etat parent sur la quantite affichee par le selecteur :
  // getProductQuantityPcb retourne 0 pour les produits multi-paliers, ce qui
  // grisait le bouton "Ajouter au panier" par defaut
  const [qtyCart, setQtyCart] = useState<number>(() => {
    const qty = getProductQuantityPcb(product, 0)

    return Number.isFinite(qty) && qty > 0 ? qty : getInitialDisplayedQty(product)
  })

  const { isAuthenticated } = useContext(ProfileContext)

  if (!product) return null
  return (
    <>
      <div className="mb-2">Sélectionnez une quantité</div>

      <div className="md:flex items-start">
        <div className="md:min-w-[450px] max-w-[600px] w-full">
          <ProductQtyInput
            product={product}
            onChange={setQtyCart}
            initialQty={qtyCart}
            showAddButton={false}
          />
        </div>

        <div className="flex justify-center items-start mt-4 md:justify-end md:items-end w-full">
          {isAuthenticated && <ProductAddToBasket qtyCart={qtyCart} product={product} />}
        </div>
      </div>
    </>
  )
}

export default ProductAddPad
